import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Switch, Route, Redirect } from "react-router-dom";
import { SubRouter } from "./SubRouter";
export const Router = ({ routes }) => {
    return (_jsxs(Switch, { children: [_jsx(Route, Object.assign({ exact: true, path: "/" }, { children: _jsx(Redirect, { to: routes[0].path }, void 0) }), void 0),
            routes.map((route, key) => (_jsx(Route, Object.assign({ path: route.path }, { children: _jsx(SubRouter, { route: route }, void 0) }), key)))] }, void 0));
};
//# sourceMappingURL=index.js.map